import React, {Component} from "react";
import { Col, Container, Row } from "react-bootstrap";
import ServiceBox from "../components/serviceBox";
import CommonService from "../services/common.service";
import configData from "../config.json";
import { withRouter } from "../utils/withRouter";
import userEventService from "../services/user-event.service";

let common = new CommonService();

interface MainPageState {
    servicesList: Array<any>;
    hotelId: string;
}

interface MainPageProps {
    params: {
        id: string;
    };
}

class MainPage extends Component<MainPageProps, MainPageState> {
    constructor(props: MainPageProps) {
        super(props);
        let hotelID = this.props.params.id ? this.props.params.id.toLowerCase() : null;
        this.state = {
            servicesList: [],
            hotelId: hotelID ? hotelID : ''
        };

        if (hotelID !== null) {
            if (!hotelID.includes('hotel_')) {
                hotelID = 'hotel_' + hotelID;
            }
            localStorage.setItem('hotel', hotelID);
        }
    }

    componentDidMount(): void {
        userEventService.sendEvent('page_view', 'main_page_open');
        common.getHeaderMenu().then(menuItems => {
            let mappedMenu = menuItems.map((item: any) => ({ 
                id: item.box_title_en, 
                route: item.box_slug, 
                title: item.box_subtitle, 
                description: item.box_title,
                image: configData.PATH + item.box_banner
            }));
            this.setState({ servicesList: mappedMenu });
            const uuid = localStorage.getItem('uuid');
            if (!uuid || uuid === '' || uuid === undefined) {
                common.getUID().then((uid: any) => {
                    if (uid && uid.uuid) {
                        localStorage.setItem('uuid', uid.uuid);
                    }
                    else {
                        localStorage.setItem('uuid', '');
                    }
                });
            }
        });
    }

    render() {
        return (
            <>
                <Container className="oc-mainpage">
                    <Row>
                        { this.state.servicesList.map(service => (
                            <Col key={service.id} lg={6} md={6} sm={12} xs={12}>
                                <ServiceBox 
                                id={service.id} 
                                route={service.route} 
                                title={service.title} 
                                description={service.description} 
                                image={service.image}></ServiceBox>
                            </Col>
                        )) }
                    </Row>
                </Container>
            </>
        );
    }
}

export default withRouter(MainPage);